export default __webpack_public_path__ + "static/media/A705F51F-AEAB-414F-A274-BC470BF81472_1_105_c.352c47b9.jpeg";